import numeral from 'numeral'

import 'numeral/locales/de'

// switch between locales
numeral.locale('de');
